import { render, staticRenderFns } from "./department-new.vue?vue&type=template&id=6160401c&scoped=true&"
import script from "./department-new.vue?vue&type=script&lang=js&"
export * from "./department-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6160401c",
  null
  
)

export default component.exports